import type { PopoverProps } from '@carboncopyco/ui';
import { Popover, TextBase } from '@carboncopyco/ui';

export type VariablesEmptyStateProps = Pick<
  PopoverProps,
  'open' | 'triggerElement' | 'container' | 'zIndex'
>;

export const VariablesEmptyState = ({
  open,
  triggerElement,
  container,
  zIndex,
}: VariablesEmptyStateProps) => {
  return (
    <Popover
      open={open}
      triggerElement={triggerElement}
      arrow={false}
      container={container}
      zIndex={zIndex}
    >
      <div className="flex flex-col justify-center items-center p-3 cursor-auto">
        <TextBase
          label="You have no variables yet."
          color="text-ds-natural-600"
        />
        <TextBase
          label="To add variables go to variables manager."
          color="text-ds-natural-600"
        />
      </div>
    </Popover>
  );
};
